import React from "react";
import { Link } from "react-router-dom";
import Userprofile from "./parts/Userprofile";

function Home() {
  return (
    <div className="">
      <div className="container py-6">

        {/* Header */}
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-4">
          <div>
            <h1 className="mb-1 header-title">Dashboard</h1>
            <p className="text-muted mb-0" style={{ fontSize: 14 }}>
              Welcome back. Manage your account and access tools quickly.
            </p>
          </div>

          {/* Quick Actions - small, modern */}
          <div className="d-flex gap-2 mt-3 mt-md-0">
          <Link to="/msmart" className="ds-chip ds-chip-dark">
            M-Smart →
          </Link>

          <Link to="/courses" className="ds-chip">
            Training →
          </Link>
        </div>
        </div>


        {/* Two big cards */}
        <div className="row g-3 align-items-stretch">
          <div className="col-12 col-lg-6 d-flex">
            <Userprofile />
          </div>

          <div className="col-12 col-lg-6 d-flex">
            <div className="card ds-card w-100 h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div>
                    <div className="text-muted" style={{ fontSize: 13 }}>
                      Quick Actions
                    </div>
                    <h4 className="mb-0 fw-bold">Tools</h4>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-12">
                    <Link to="/msmart" className="ds-tile">
                      <div className="ds-icon">📊</div>
                      <div className="flex-grow-1">
                        <div className="fw-semibold">M-Smart CRM</div>
                        <div className="text-muted" style={{ fontSize: 13 }}>
                          Leads, activities & stats
                        </div>
                      </div>
                      <div className="ds-arrow">→</div>
                    </Link>
                  </div>

                  <div className="col-12">
                    <Link to="/courses" className="ds-tile">
                      <div className="ds-icon">🎓</div>
                      <div className="flex-grow-1">
                        <div className="fw-semibold">Training Centre</div>
                        <div className="text-muted" style={{ fontSize: 13 }}>
                          Courses, scripts & resources
                        </div>
                      </div>
                      <div className="ds-arrow">→</div>
                    </Link>
                  </div>

                  <div className="col-12">
                    <Link to="/change-password" className="ds-tile">
                      <div className="ds-icon">🔒</div>
                      <div className="flex-grow-1">
                        <div className="fw-semibold">Account Settings</div>
                        <div className="text-muted" style={{ fontSize: 13 }}>
                          Password & login security
                        </div>
                      </div>
                      <div className="ds-arrow">→</div>
                    </Link>
                  </div>
                </div>

                <div className="mt-4 text-muted" style={{ fontSize: 13 }}>
                  Tip: Click a tile to open the module.
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Home;
